<button id="{{buttonId}}" style="display:none;" data-bs-toggle="modal" [attr.data-bs-target]="'#' + modalId"></button>

<div class="modal" [id]="modalId" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-main-content">
        <h2 class="modal-heading center" tabindex="0">{{title}}</h2>
        <div class="modal-body">
          <h5 tabindex="0">{{message}}</h5>
          
          <div class="clear full-width pull-left">
            <div class="button-container-center mt-20">
              <button [id]="cancelButtonId" type="button" class="modal-button delete-close" 
              data-bs-dismiss="modal" (click)="cancel.emit()">{{cancelText}}</button>
              <button [id]="confirmButtonId" data-bs-dismiss="modal" 
              class="modal-button yes-button" (click)="confirm.emit()" 
              type="button">{{confirmText}}</button>
            </div>
          </div>
        </div>
        <button [id]="closeId" class="close delete-close" (keydown.enter)="cancel.emit()">
          <img [src]="closeIconPath" data-bs-dismiss="modal" alt="Close">
        </button>
      </div>
    </div>
  </div>
</div>